var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.3 1A1.3 1.3 0 0 0 3 2.3v.244a4.5 4.5 0 0 0 1.737 3.552L7.186 8 4.737 9.904A4.5 4.5 0 0 0 3 13.456v.244A1.3 1.3 0 0 0 4.3 15h7.4a1.3 1.3 0 0 0 1.3-1.3v-.244a4.5 4.5 0 0 0-1.737-3.552L8.814 8l2.449-1.904A4.5 4.5 0 0 0 13 2.544V2.3A1.3 1.3 0 0 0 11.7 1H4.3ZM4 2.3a.3.3 0 0 1 .3-.3h7.4a.3.3 0 0 1 .3.3v.244c0 .509-.11 1.005-.317 1.456H4.317A3.498 3.498 0 0 1 4 2.544V2.3ZM5.007 5h5.986a3.499 3.499 0 0 1-.344.306L8.184 7.223a.3.3 0 0 1-.368 0L5.35 5.306A3.503 3.503 0 0 1 5.007 5ZM4 13.41l3.47-2.168a1 1 0 0 1 1.06 0L12 13.41a3.5 3.5 0 0 0-1.351-2.716L8.184 8.777a.3.3 0 0 0-.368 0L5.35 10.694a3.5 3.5 0 0 0-1.35 2.716Zm7.057.59L8 12.09 4.943 14h6.114Z",
    clipRule: "evenodd"
  })));
};
export default SvgTimer;